import React, { useRef } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import styled from 'styled-components';
import GridView from 'assets/grid-view.svg';
import ListView from 'assets/list-view.svg';
import TileView from 'assets/tile-view.svg';
import { View } from "./constants";
import {FormattedMessage} from "react-intl";

const getView = (view: View) => {
  switch (view) {
    case View.Tile: {
      return (
        <ViewContainer>
          <TileView />
          <ViewTitle>
            <FormattedMessage
              id="Releases.ViewSelector.TileView"
              defaultMessage="Tile view"
            />
          </ViewTitle>
        </ViewContainer>
      );
    }
    case View.List: {
      return (
        <ViewContainer>
          <ListView />
          <ViewTitle>
            <FormattedMessage
              id="Releases.ViewSelector.ListView"
              defaultMessage="List view"
            />
          </ViewTitle>
        </ViewContainer>
      );
    }
    case View.Grid:
    default: {
      return (
        <ViewContainer>
          <GridView />
          <ViewTitle>
            <FormattedMessage
              id="Releases.ViewSelector.GridView"
              defaultMessage="Grid view"
            />
          </ViewTitle>
        </ViewContainer>
      );
    }
  }
};

interface ViewSelectorProps {
  view: View;
  onChangeView: (view: View) => void;
  hideTile?: boolean;
}

export const ViewSelector: React.FC<ViewSelectorProps> = props => {
  const { view, onChangeView, hideTile } = props;
  const op = useRef<OverlayPanel>(null);

  const handleClick = (event: React.MouseEvent) => {
    op.current?.toggle(event);
  };

  return (
    <>
      <Button onClick={handleClick}>{getView(view)}</Button>
      <OverlayPanel ref={op} dismissable>
        <MenuContainer>
          <MenuItem
            $isActive={view === View.Grid}
            onClick={(event) => {
              onChangeView(View.Grid);
              handleClick(event);
            }}
          >{getView(View.Grid)}</MenuItem>
          <MenuItem
            $isActive={view === View.List}
            onClick={(event) => {
              onChangeView(View.List);
              handleClick(event);
            }}
          >{getView(View.List)}</MenuItem>
          {!hideTile && (
            <MenuItem
              $isActive={view === View.Tile}
              onClick={(event) => {
                onChangeView(View.Tile);
                handleClick(event);
              }}
            >
              {getView(View.Tile)}
            </MenuItem>
          )}
        </MenuContainer>
      </OverlayPanel>
    </>
  );
};


const Button = styled.button`
  background: transparent;
  border: none;
  color: #aaa;
  font-size: 15px;
  font-weight: 400;
  line-height: 18px;
  cursor: pointer;
`;

const MenuContainer = styled.div`
  // padding: 15px 20px;
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 130px;
`;

const MenuItem = styled.div<{ $isActive: boolean }>`
  cursor: pointer;
  opacity: ${props => props.$isActive ? 1 : 0.6};
  
  &:hover {
    opacity: 1;
  }
`;

const ViewContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #6777FF;
`;

const ViewTitle = styled.span`
  white-space: nowrap;
`;
